<template>
  <div id="aggregateList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" type="text" v-model="searchData.menuName" placeholder="标题">
          </p>
          <button @click="getAggregateList(1)" class="redButtonTwo">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="addNew">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div style="width: 100%;">
        <table cellspacing="0" class="allTable" style="width:100%;table-layout: fixed">
          <thead>
          <tr>
            <th width="15%" class="">菜单排序</th>
            <th width="15%"  class="">菜单名称</th>
            <th  width="50%"  class="">跳转链接</th>
            <th width="20%" class="">操作</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="aggregateList.length > 0">
              <tr :key="index" v-for="(item, index) in aggregateList">
                <td  class="NoWrap" :title="item.menusort">{{item.menusort}}</td>
                <td class="NoWrap" :title="item.menuName">{{item.menuName}}</td>
                <td class="NoWrap" :title="item.jumpUrl">{{item.jumpUrl}}</td>
                <td>
                  <div class="icon more iconfont icongengduo moreOperations">
                    <ul>
                      <li @click="editItem(item)">编辑</li>
                      <li @click="deleteTag(item)">删除</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="8">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getAggregateList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!-- 新建 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="height:250px;width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>菜单名称</span>
            <input maxlength="10" v-model="modelData.menuName" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>菜单排序</span>
            <input maxlength="50" v-model="modelData.menusort" type="number" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>跳转链接</span>
            <input v-model="modelData.jumpUrl" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
          <li>
            <div class="split_3_7 m_t_10">
              <div class='required'>上传图标</div>
              <div style="white-space: nowrap">
                <!-- <input type="text" class="allInput w100 p_8 b_b" placeholder="请输入直播名称"/> -->
                  <input @change="clopuploadImg($event,2)" type="file" id="inFile" class="coverFile" accept="image/*"/>
                  <label style="width: 225px;height: 125px;" for="inFile">
                    <div v-if="modelData.iconPath">
                      <img :src="modelData.iconPath" width="225" height="125" style="border-radius: 8px"/>
                    </div>
                    <div v-else style="margin-top: 20px">
                      <span style="color: #DCDCDC;font-size: 50px">+</span>
                    </div>
                  </label>
                 
              </div>
            </div>
          </li>
          
        </ul>
      </div>
    </model>
 
  </div>
</template>
<script>
export default {
  name: 'aggregateList',
  data () {
    return {
      aggregateList:[],
      searchData: {
        // status: 2, // 和全部内容页面传的一样
        menuName:"",
        userID:"",
      },
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      isOnlyParent: false, // 只显示父级标签
      isadmin: JSON.parse(window.localStorage.getItem('isAdmin')), // 管理员
      //fieldsListNew: [],
      fieldsList: [], // 领域
      //indicationsListNew: [],
      indicationsList: [], // 适应症
      //departmentListNew: [],
      departmentList: [], // 科室
      page: 1,
      pageSize: 10,
      totalPage: 0,
      totalCount: 0,
      tagList: [],
      showModel: false,
      showModelImport:false,
      FilePD: 'False',
      modelTitle: '',
      modelData: {
        id:0,
        menusort:"",
        menuName:"",
        jumpUrl:"",
        iconPath:"",
        userID:"",
      },
      parentTagList: [], // 父标签下拉列表
      allProduct: [], // 所有产品组
      productList: JSON.parse(window.localStorage.getItem('productList')) || [], // 产品组
    }
  },
  created () {
    // 获取聚合页列表
    this.getAggregateList(1)
  },
  mounted () {

  },
  methods: {
    // 获取聚合页列表
    getAggregateList (page) {
      this.page = page
      let data = JSON.parse(JSON.stringify(this.searchData)) 
      data.userID = this.userInfo.id
      data.isadmin = this.isadmin
      let params = {
        pageIndex: page,
        pageSize: this.pageSize
      }
      let url = this.$commonJs.returnQuery('/api/Article/QueryAggregate', data)
      this.$axiox.post(url, params).then(res => {
        console.log(res, '获取聚合页列表')
        if (res.data && res.data.length > 0) {
          this.aggregateList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.aggregateList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },

    clopuploadImg (e) {
      // 上传图片
      var file = e.target.files[0]
      this.signalUpload(file)
    },
    async signalUpload (e) {
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.modelData.iconPath = await this.$commonJs.uploadFile(fileImg, '/api/Article/AddAggregateThumb', 'formFile')
        document.getElementById('inFile').value = ''
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    
    
    // 新建标签
    addNew () {
      this.modelTitle = '新建'
      this.showModel = true
    },

    confirModel () {
      this.modelData.userID=this.userInfo.id
      console.log(this.modelData, 'modelData')

      if (this.modelTitle == '新建') {
        // 新建
        console.log(this.modelData, 'modelData')
        if (this.modelData.menuName && this.modelData.menusort && this.modelData.jumpUrl && this.modelData.iconPath) {
          let params = {
            menuname: this.modelData.menuName,
            menusort: this.modelData.menusort,
            jumpurl: this.modelData.jumpUrl,
            iconpath: this.modelData.iconPath,
            userid: this.modelData.userID
          }
          this.$axiox.post(`/api/Article/AddAggregate`, params).then(res => {

            if(res==-9){

              this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '跳转链接格式有误！',
              stayTime: 5
              })
              return;
            }

            if(res==-8){

              this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '菜单排序请输入数字！',
              stayTime: 5
              })
              return;
            }

            if(res==-7){

              this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '菜单排序已存在！',
              stayTime: 5
              })
              return;
            }

            if (res) {
              // 获取列表
              this.getAggregateList(1)
              
              this.showModel = false
              this.modelData.menuName = ""
              this.modelData.menusort = ""
              this.modelData.jumpUrl = ""
              this.modelData.iconPath = ""
              this.modelData.userID = ""
            }
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
        }
      } else {
        // 编辑
        if (this.modelData.menuName && this.modelData.menusort && this.modelData.jumpUrl && this.modelData.iconPath) {
          let params = {
            aggid: this.modelData.id,
            menuname: this.modelData.menuName,
            menusort: parseInt(this.modelData.menusort),
            jumpurl: this.modelData.jumpUrl,
            iconpath: this.modelData.iconPath,
            userid: this.modelData.userID
          }
          this.$axiox.put(`/api/Article/UpdateAggregate`, params).then(res => {
if(res==-9){

this.$commonJs.alertTips({
type: 'error',
title: '失败',
content: '跳转链接格式有误！',
stayTime: 5
})
return;
}

if(res==-8){

this.$commonJs.alertTips({
type: 'error',
title: '失败',
content: '菜单排序请输入数字！',
stayTime: 5
})
return;
}

if(res==-7){

this.$commonJs.alertTips({
type: 'error',
title: '失败',
content: '菜单排序已存在！',
stayTime: 5
})
return;
}

            if (res) {
              // 获取列表
              this.getAggregateList(1)

              this.showModel = false
              this.modelData.menuName = ""
              this.modelData.menusort = ""
              this.modelData.jumpUrl = ""
              this.modelData.iconPath = ""
              this.modelData.userID = ""
            }
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
        }
      }
    },
    
    cancelModel () {
      this.showModel = false
      this.modelData.menuName = ""
      this.modelData.menusort = ""
      this.modelData.jumpUrl = ""
      this.modelData.iconPath = ""
      this.modelData.userID = ""
    },

    // 编辑
    editItem (item) {
      this.modelTitle = '编辑'
      this.modelData.id=item.id
      this.modelData.menuName = item.menuName
      this.modelData.menusort = item.menusort
      this.modelData.jumpUrl = item.jumpUrl
      this.modelData.iconPath = item.iconPath
      this.showModel = true
    },

    deleteTag (item) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除？',
        successFun: msg => {
          this.$axiox.del('/api/Article/DeleteAggregate/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            // 获取列表
            this.getAggregateList(1)
            
          })
        },
        errorFun: msg => {
        }
      })
    },

  },
 
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/aggregateManager/aggregateList.vue